exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gw-product-requirements,gw-product-requirements{position:relative;display:block}.gw-product-requirements__traveler{position:absolute;top:0;right:0;margin-top:.75em;width:16.25em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./resources/assets/js/components/product-requirements/product-requirements.scss
// module id = ephg
// module chunks = 1